import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { Typography, withTypography } from 'ucl/components/text/Typography';

import { getDesignToken } from 'styles/constants';

export const ReceiptDetail = Box.withConfig<{ $total?: boolean }>(p => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginY: p.$total ? '$3' : 0,
  accessible: true,
  focusable: true,
}));

export const FeeDeliveryItem = withTypography({ m: '$0', fontFamily: 'heading' });

export const RewardsDiscountDetail = ReceiptDetail.withConfig({
  _text: {
    color: getDesignToken('text-default'),
    fontFamily: 'brand',
  },
});

export const SDiscount = withTypography({ style: { textDecorationLine: 'line-through' } });

export const ReceiptDetailsText = ({
  $total,
  ...props
}: React.ComponentPropsWithoutRef<typeof Typography> & { $total?: boolean }) =>
  React.createElement(Typography, {
    variant: $total ? 'copyOne' : 'copyTwo',
    bold: $total,
    ...props,
  });
